/* theme.core.js — split verbatim from Shrine main.js (deobfuscated 2026-10-14).
   Load order: theme.core → theme.cart → theme.search → theme.product → theme.deals → theme.extras → theme.license-guard. */

const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    optionValueSelectionChange: "option-value-selection-change",
    variantChange: "variant-change",
    cartError: "cart-error"
  },
  POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe(arg, arg2) {
  subscribers[arg] === undefined && (subscribers[arg] = []);
  subscribers[arg] = [...subscribers[arg], arg2];
  return function fn() {
    subscribers[arg] = subscribers[arg].filter(item => {
      return item !== arg2;
    });
  };
}
function publish(arg, arg2) {
  subscribers[arg] && subscribers[arg].forEach(item => {
    item(arg2);
  });
}
const GIFTS_LOCAL_STORAGE_KEY = "shrine_gift_goals";
let shouldCheckShrineGifts = false,
  giftsToMonitor = [];
function initShrineGiftsCheck(arg = false) {
  let el = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (arg) el = document.querySelector("cart-items");
  if (!el || el.dataset.giftsStorage !== "true") return;
  const stored = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (!stored) return;
  const data = JSON.parse(stored);
  if (!data || typeof data !== "object") return;
  Object.values(data).forEach(item => {
    const el2 = el.querySelector(".cart-item--product-" + item.gift_handle);
    if (!el2) return;
    const el3 = document.querySelector(".gift--product-" + item.gift_handle);
    if (el3) return;
    shouldCheckShrineGifts = true;
    giftsToMonitor.push(item);
  });
  updateGiftStyles();
  checkShrineGifts(arg);
}
function updateGiftStyles() {
  let el = document.getElementById("shrine-gifts-style");
  if (el) el.remove();
  if (!giftsToMonitor.length) return;
  const el2 = document.createElement("style");
  el2.id = "shrine-gifts-style";
  const joined = giftsToMonitor.map(item => ".cart-item--product-" + item.gift_handle + " .quantity { display: none !important; }").join("\n");
  el2.textContent = joined;
  document.head.appendChild(el2);
}
function checkShrineGifts(arg = false) {
  let el = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (arg) el = document.querySelector("cart-items");
  if (!shouldCheckShrineGifts || !el || !el.updateQuantity) return;
  for (const value of giftsToMonitor) {
    const el2 = el.querySelector(".cart-item--product-" + value.gift_handle);
    if (!el2) {
      const index = giftsToMonitor.findIndex(item => item.gift_handle === value.gift_handle);
      if (index > -1) giftsToMonitor.splice(index, 1);
      removeLocalStorageGift(value);
      continue;
    }
    let flag = false;
    if (value.type === "product_quantity") {
      let num = 0;
      el.querySelectorAll(".cart-item--product-" + value.unlock_product_handle).forEach(item => {
        num += parseInt(item.dataset.quantity);
      });
      if (num < parseInt(value.required_quantity)) flag = true;
    } else {
      if (value.type === "product_variant") {
        const els = el.querySelectorAll(".cart-item--product-" + value.unlock_product_handle);
        if (!els.length) flag = true;else {
          const valid_variants = Array.isArray(value.valid_variants) ? value.valid_variants : [];
          let flag2 = false,
            flag3 = false;
          els.forEach(item => {
            const variantOptions = item.dataset.variantOptions;
            if (variantOptions) {
              flag3 = true;
              const mapped = variantOptions.split("|||").map(item2 => item2.trim().toLowerCase());
              mapped.some(item2 => valid_variants.includes(item2)) && (flag2 = true);
            }
          });
          if (flag3 && !flag2) flag = true;
        }
      } else {
        const parseIntResult = parseInt(el.dataset.subtotal);
        if (parseIntResult < parseInt(value.required_quantity)) flag = true;
      }
    }
    if (flag) {
      const index = giftsToMonitor.findIndex(item => item.gift_handle === value.gift_handle);
      if (index > -1) giftsToMonitor.splice(index, 1);
      removeLocalStorageGift(value);
      const index2 = el2.dataset.index ?? el2.id.replace("CartItem-", "");
      el.updateQuantity(index2, 0);
      return;
    }
  }
}
function validateSingleQuantityCartItems(el, arg) {
  for (const [value, value2] of Object.entries(arg)) {
    const els = el.querySelectorAll(".cart-item--product-" + value);
    if (els.length === 0) continue;
    if (els.length > 1) {
      let value3 = null,
        arr = [];
      els.forEach(item => {
        const el2 = item.querySelector("[data-quantity-variant-id]"),
          quantityVariantId = el2 ? el2.dataset.quantityVariantId : null;
        quantityVariantId === value2 && !value3 ? value3 = item : arr.push(item);
      });
      !value3 && arr.length > 0 && (value3 = arr.shift());
      if (arr.length > 0) {
        const item = arr[0],
          index = item.dataset.index ?? item.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
        el.updateQuantity(index, 0);
        return true;
      }
    }
    if (els.length === 1) {
      const item = els[0],
        parseIntResult = parseInt(item.dataset.quantity) || 1;
      if (parseIntResult > 1) {
        const index = item.dataset.index ?? item.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
        el.updateQuantity(index, 1);
        return true;
      }
    }
  }
  return false;
}
function validateCartGifts(arg = false) {
  const el = document.querySelector("cart-drawer");
  if (!el) return;
  let el2 = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (arg) el2 = document.querySelector("cart-items");
  if (!el2 || !el2.updateQuantity) return;
  const els = el.querySelectorAll("cart-drawer-gift"),
    els2 = el.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"]");
  if (!els.length && !els2.length) return;
  const obj = {};
  els.forEach(item => {
    item.dataset.handle && item.dataset.id && item.dataset.selected === "true" && (obj[item.dataset.handle] = item.dataset.id);
  });
  const obj2 = {};
  els2.forEach(item => {
    item.dataset.handle && item.dataset.id && item.dataset.selected === "true" && (obj2[item.dataset.handle] = item.dataset.id);
  });
  if (validateSingleQuantityCartItems(el2, obj)) return;
  if (validateSingleQuantityCartItems(el2, obj2)) return;
}
function removeLocalStorageGift(arg) {
  const stored = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (stored) try {
    const data = JSON.parse(stored);
    data && data[arg.gift_handle] && (delete data[arg.gift_handle], localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(data)));
  } catch (error) {
    console.warn("Error parsing gift localStorage data:", error);
  }
}
var date = "2027-10-10";
var search = "search";
var serial = "";
const defMed = "data-defer";
function serializePropValue(arg) {
  if (arg == null) return "";
  if (typeof arg === "object") try {
    return JSON.stringify(arg);
  } catch {
    return String(arg);
  }
  return String(arg);
}
function getFocusableElements(el) {
  return Array.from(el.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(item => {
  item.setAttribute("role", "button");
  item.setAttribute("aria-expanded", item.parentNode.hasAttribute("open"));
  item.nextElementSibling?.["getAttribute"]("id") && item.setAttribute("aria-controls", item.nextElementSibling.id);
  item.addEventListener("click", event => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });
  if (item.closest("header-drawer")) return;
  item.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(arg, arg2 = arg) {
  var getFocusableElementsResult = getFocusableElements(arg),
    item = getFocusableElementsResult[0],
    item2 = getFocusableElementsResult[getFocusableElementsResult.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = arg3 => {
    if (arg3.target !== arg && arg3.target !== item2 && arg3.target !== item) return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    event.target === item2 && !event.shiftKey && (event.preventDefault(), item.focus());
    (event.target === arg || event.target === item) && event.shiftKey && (event.preventDefault(), item2.focus());
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  arg2.focus();
  arg2.tagName === "INPUT" && ["search", "text", "email", "url"].includes(arg2.type) && arg2.value && arg2.setSelectionRange(0, arg2.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(item => {
    item.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(item => {
    item.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(item => item.pause());
  document.querySelectorAll("product-model").forEach(item => {
    if (item.modelViewerUI) item.modelViewerUI.pause();
  });
}
var menuIndex = "body",
  linkContent = "innerHTML";
function removeTrapFocus(arg = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (arg) arg.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const parentEl = event.target.closest("details[open]");
  if (!parentEl) return;
  const el = parentEl.querySelector("summary");
  parentEl.removeAttribute("open");
  el.setAttribute("aria-expanded", false);
  el.focus();
}
function debounce(arg, arg2) {
  let value;
  return (...arg3) => {
    clearTimeout(value);
    value = setTimeout(() => arg.apply(this, arg3), arg2);
  };
}
function fetchConfig(arg = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + arg
    }
  };
}
function addDays(arg, arg2) {
  var date2 = new Date(arg);
  date2.setDate(date2.getDate() + arg2);
  return date2;
}
function formatDates(arg, arg2, arg3 = 27) {
  if (!arg || !arg2) return;
  const date2 = new Date(arg2 + "T00:00:00Z"),
    getFullYear = date2.getFullYear(),
    getMonth = date2.getMonth(),
    getDate = date2.getDate(),
    date3 = new Date(getFullYear, getMonth, getDate),
    value = arg - date3,
    ceil = Math.ceil(value / (1000 * 3600 * 24));
  return ceil <= arg3;
}
function checkDateValidity(arg) {
  const date2 = new Date(arg),
    date3 = new Date("2023-01-01T00:00:00Z"),
    abs = Math.abs(date2.getDate() - date3.getDate());
  return abs % 5 === 0 ? true : false;
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function (arg, arg2) {
  return function () {
    return arg.apply(arg2, arguments);
  };
};
Shopify.setSelectorByValue = function (arg, arg2) {
  for (var num = 0, count = arg.options.length; num < count; num++) {
    var item = arg.options[num];
    if (arg2 == item.value || arg2 == item.innerHTML) {
      arg.selectedIndex = num;
      return num;
    }
  }
};
Shopify.addListener = function (el, arg, arg2) {
  el.addEventListener ? el.addEventListener(arg, arg2, false) : el.attachEvent("on" + arg, arg2);
};
Shopify.postLink = function (arg, arg2) {
  arg2 = arg2 || {};
  var method = arg2.method || "post",
    parameters = arg2.parameters || {},
    el = document.createElement("form");
  el.setAttribute("method", method);
  el.setAttribute("action", arg);
  for (var value in parameters) {
    var el2 = document.createElement("input");
    el2.setAttribute("type", "hidden");
    el2.setAttribute("name", value);
    el2.setAttribute("value", parameters[value]);
    el.appendChild(el2);
  }
  document.body.appendChild(el);
  el.submit();
  document.body.removeChild(el);
};
Shopify.internationalAccessAccept = function () {
  function fn() {
    var language = navigator.language || navigator.userLanguage;
    return language.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
  }
  function fn2() {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone.startsWith("Europe") || timeZone.startsWith("America") || timeZone.includes("GMT");
  }
  function fn3() {
    var symbol = Shopify.currency.symbol || "$";
    return symbol.length === 1;
  }
  function fn4() {
    var stored = localStorage.getItem(POST_LINK_INT),
      count = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (stored === null) {
      localStorage.setItem(POST_LINK_INT, count.toString());
      return true;
    }
    return parseInt(stored) === count;
  }
  function fn5() {
    return fn() || fn2() && fn3();
  }
  function fn6() {
    return window.performance && typeof window.performance.timing === "object";
  }
  return function () {
    var fn5Result = fn5(),
      fn6Result = fn6(),
      fn4Result = fn4();
    Shopify.postLinksRetry = !fn4Result;
    return fn5Result && fn6Result && fn4Result;
  };
}();
Shopify.CountryProvinceSelector = function (arg, arg2, arg3) {
  this.countryEl = document.getElementById(arg);
  this.provinceEl = document.getElementById(arg2);
  this.provinceContainer = document.getElementById(arg3.hideElement || arg2);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var attrValue = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, attrValue);
    this.countryHandler();
  },
  initProvince: function () {
    var attrValue = this.provinceEl.getAttribute("data-default");
    attrValue && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, attrValue);
  },
  countryHandler: function (arg) {
    var item = this.countryEl.options[this.countryEl.selectedIndex],
      attrValue = item.getAttribute("data-provinces"),
      data = JSON.parse(attrValue);
    this.clearOptions(this.provinceEl);
    if (data && data.length == 0) this.provinceContainer.style.display = "none";else {
      for (var num = 0; num < data.length; num++) {
        var item = document.createElement("option");
        item.value = data[num][0];
        item.innerHTML = data[num][1];
        this.provinceEl.appendChild(item);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (arg) {
    while (arg.firstChild) {
      arg.removeChild(arg.firstChild);
    }
  },
  setOptions: function (el, list) {
    for (var num = 0, count = list.length; num < list.length; num++) {
      var el2 = document.createElement("option");
      el2.value = list[num];
      el2.innerHTML = list[num];
      el.appendChild(el2);
    }
  }
};
var isIe = true;
function _qbGetPresentmentRate(arg) {
  if (!arg) return null;
  const shopify = window.Shopify;
  if (!shopify || !shopify.currency) return null;
  const active = shopify.currency.active,
    parseFloatResult = parseFloat(shopify.currency.rate);
  if (!active || !parseFloatResult || parseFloatResult === 1) return null;
  if (active === arg) return null;
  return parseFloatResult;
}
function updateGiftGoalInStorage({
  giftHandle: arg,
  giftVariantId: arg2,
  unlockType: arg3,
  unlockRequirement: arg4,
  unlockTarget: arg5
}) {
  const data = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
  if (!arg || !arg2 || !arg4 || !arg3) return;
  const obj = {
    type: arg3,
    gift_handle: arg,
    gift_variant_id: Number(arg2),
    unlock_product_handle: arg5 || null
  };
  arg3 === "product_variant" ? Array.isArray(arg4) ? obj.valid_variants = arg4.map(item => String(item).toLowerCase().trim()) : obj.valid_variants = [String(arg4).toLowerCase().trim()] : obj.required_quantity = Number(arg4);
  data[arg] = obj;
  localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(data));
}
function displayPrices(arg, arg2, arg3, el, arg4) {
  if (!arg4) return;
  if (arg && arg3) {
    var formattedPrice = formatMoney(arg, arg4);
    arg3.innerHTML = formattedPrice;
  }
  if (arg2 && el) {
    var formattedPrice2 = formatMoney(arg2, arg4);
    el.innerHTML = formattedPrice2;
    arg2 > arg ? el.classList.remove("hidden") : el.classList.add("hidden");
  }
}
function formatMoney(arg, arg2, arg3 = false) {
  typeof arg == "string" && (arg = arg.replace(".", ""));
  var str = "",
    value = /\{\{\s*(\w+)\s*\}\}/,
    value2 = arg2;
  function fn(arg4, arg5) {
    return typeof arg4 == "undefined" ? arg5 : arg4;
  }
  function fn2(arg4, arg5, arg6, arg7) {
    arg5 = fn(arg5, 2);
    arg6 = fn(arg6, ",");
    arg7 = fn(arg7, ".");
    if (isNaN(arg4) || arg4 == null) return 0;
    arg4 = (arg4 / 100).toFixed(arg5);
    var parts = arg4.split("."),
      replaced = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + arg6),
      value3 = parts[1] ? arg7 + parts[1] : "";
    arg3 && value3 === arg7 + "00" && (value3 = "");
    return replaced + value3;
  }
  switch (value2.match(value)[1]) {
    case "amount":
      str = fn2(arg, 2);
      break;
    case "amount_no_decimals":
      str = fn2(arg, 0);
      break;
    case "amount_with_comma_separator":
      str = fn2(arg, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      str = fn2(arg, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      str = fn2(arg, 2, " ", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      str = fn2(arg, 0, " ", ",");
      break;
    case "amount_with_apostrophe_separator":
      str = fn2(arg, 2, "'", ".");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      str = fn2(arg, 0, "'", ".");
      break;
  }
  return value2.replace(value, str);
}
